import { render, staticRenderFns } from "./RequestTraining.vue?vue&type=template&id=6725977c&scoped=true&"
import script from "./RequestTraining.vue?vue&type=script&lang=js&"
export * from "./RequestTraining.vue?vue&type=script&lang=js&"
import style0 from "./RequestTraining.vue?vue&type=style&index=0&id=6725977c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6725977c",
  null
  
)

export default component.exports